import { apiClient } from './client';
export const integrationsApi = {
    getIntegrationConnections: (workspaceId) => apiClient.get(`/api/Integrations/Workspace/${workspaceId}`),
    createIntegrationConnection: (dto) => apiClient.post('/api/Integrations/CreateIntegrationConnection', dto),
    updateIntegrationConnection: (workspaceId, id, dto) => apiClient.put(`/api/Integrations/Workspace/${workspaceId}/${id}`, dto),
    deleteIntegrationConnection: (workspaceId, id) => apiClient.delete(`/api/Integrations/Workspace/${workspaceId}/${id}`),
    // View (decrypt) existing API key for an integration connection. Returns { key: string }
    viewIntegrationConnectionKey: async (workspaceId, id) => {
        return apiClient.get(`/api/Workspaces/${workspaceId}/IntegrationConnections/${id}/Key`);
    },
    // Generate a new globally unique API key for a provider (not persisted until used in create/update payload). Returns { apiKey: string }
    generateIntegrationApiKey: async (provider) => {
        return apiClient.post(`/api/IntegrationProviders/${provider}/GenerateApiKey`, {});
    },
};
